import React, { useState, useEffect } from 'react';
import { getCurrentLanguage, setLanguage } from '../utils/i18n';
import './LanguageSwitch.css';

/**
 * 语言切换组件
 * 简洁的圆形按钮设计
 */
const LanguageSwitch = () => {
  const [currentLang, setCurrentLang] = useState(getCurrentLanguage());
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // 监听语言变化
    const handleLanguageChange = (e) => {
      setCurrentLang(e.detail);
    };
    
    window.addEventListener('languageChange', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    setCurrentLang(lang);
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="language-switch">
      <button 
        className="language-button" 
        onClick={toggleMenu}
        title={currentLang === 'zh' ? '切换语言' : 'Switch Language'}
      >
        <span className="language-icon">
          <i className="ri-global-line"></i>
        </span>
        <span className="language-text">
          {currentLang === 'zh' ? '中文' : 'EN'}
        </span>
      </button>
      
      {isOpen && (
        <div className="language-menu">
          <div 
            className={`language-option ${currentLang === 'zh' ? 'active' : ''}`}
            onClick={() => handleLanguageChange('zh')}
          >
            <span className="option-flag">🇨🇳</span>
            <span className="option-text">中文</span>
            {currentLang === 'zh' && <i className="ri-check-line"></i>}
          </div>
          <div 
            className={`language-option ${currentLang === 'en' ? 'active' : ''}`}
            onClick={() => handleLanguageChange('en')}
          >
            <span className="option-flag">🇺🇸</span>
            <span className="option-text">English</span>
            {currentLang === 'en' && <i className="ri-check-line"></i>}
          </div>
        </div>
      )}
      
      {isOpen && (
        <div className="language-overlay" onClick={() => setIsOpen(false)}></div>
      )}
    </div>
  );
};

export default LanguageSwitch;

